import * as webbase from './routes';

export default webbase;
